import { GxButton } from '@garpix/garpix-web-components-react'
import React from 'react'
import classNames from 'classnames'
import style from './styles/button.module.scss'

interface ButtonProps {
  theme: string
  className?: string
  size: string
  wide: boolean
  corner: boolean
  highLight?: boolean
  outline?: boolean
}

/**
 * @param theme Цвет кнопки (primary, secondary)
 * @param className Класс для стилей на странице
 * @param size Размер (medium, large, extralarge)
 * @param wide Во всю ширину блока
 * @param corner Без закругления снизу
 * @param highlight Блик при наведении
 */
const Button = ({
  theme = 'primary',
  className = '',
  size = 'medium',
  wide = false,
  corner = false,
  highlight = false,
  outline = false,
  children,
  ...props
}): React.ReactElement<ButtonProps> => {
  const buttonTheme = outline ? 'outline' : theme

  return (
    <GxButton
      className={classNames({
        [style.default]: true,
        [style[`theme_${buttonTheme}`]]: buttonTheme,
        [style[`size_${size}`]]: size,
        [style.wide]: wide,
        [style.corner]: corner,
        [style.highlight]: highlight,
        [className]: className
      })}
      variant='primary'
      outline={outline}
      {...props}
    >
      {children}
    </GxButton>
  )
}

export default Button
